import React, { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { MailOutlined } from "@ant-design/icons";
import styled from "styled-components";

const Layout = styled.div`
  background: #f6f6f6;
  font-family: "Oswald" sans-serif;
  padding-top: 50px;
  .container {
    display: grid;
    justify-content: center;
    padding: 100px 5%;
    @media (max-width: 768px) {
      padding: 100px 5%;
      justify-content: flex-start;
    }
  }
  .form-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
    @media (max-width: 768px) {
      grid-template-columns: 2fr;
    }
  }
  .form {
    width: 820px;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
  .check-container {
    display: grid;
    grid-template-columns: repeat(3, 210px);

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  textarea {
    width: 100%;
    min-height: 145px;
    height: auto;
    background: ${(props) => props.theme.inputBg};
    box-shadow: -3px 3px 12px rgba(172, 0, 93, 0.12);
    border-radius: 5px;
    padding: 14px 18px;
    border: none;
    margin: 15px 0;
  }
  .input {
    width: 100%;
    max-width: 500px;
    height: 45px;
    background: ${(props) => props.theme.inputBg};
    box-shadow: -3px 3px 12px rgba(172, 0, 93, 0.12);
    border-radius: 5px;
    padding: 14px 18px;
    border: rgba(172, 0, 93, 0.12) 1px solid;
    margin: 15px 0 10px 0;
    @media (max-width: 767px) {
      min-width: 300px;
    }
    /* @media (width: 768px) {
      width: 470px;
    } */
  }
  .input2 {
    height: 45px;
    background: ${(props) => props.theme.inputBg};
    box-shadow: -3px 3px 12px rgba(172, 0, 93, 0.12);
    border-radius: 5px;
    padding: 14px 18px;
    border: rgba(172, 0, 93, 0.12) 1px solid;
    margin: 15px 0 10px 0;
    width: 100%;
    @media (max-width: 767px) {
      min-width: 300px;
    }
    /* @media (max-width: 768px) {
      width: 470px;
    } */
  }
  .input:focus {
    outline: 2px solid #f039ad;
    border-radius: 5px;
    border: rgba(172, 0, 93, 0.12) 1px solid;
  }
  .input2:focus {
    outline: 2px solid #f039ad;
    border-radius: 5px;
  }
  label {
    font-style: normal;
    font-weight: 500;
    font-size: 16.99999px;
    line-height: 15px;
    letter-spacing: 0.04em;
    text-transform: capitalize;
    font-family: "Oswald", sans-serif;
    @media (max-width: 768px) {
      font-size: 140%;
    }
  }
  .error {
    font-style: normal;
    font-weight: normal;
    font-size: 14.6666px;
    line-height: 15px;
    letter-spacing: 0.04em;
    color: red;
    opacity: 0.6;
    margin-left: 15px;
    margin-bottom: 12px;
  }

  .title {
    font-family: "Oswald", sans-serif;
    font-size: 16.66px;
    display: inline-block;
    max-width: 100%;
    margin-bottom: 11.5px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .btn-primary {
    padding: 14px 18px;
    margin: 0 15px 5px 0px;
    border-radius: 2px;
    font-family: "Arvo", serif;
    color: #6a6a6a;
    font-size: 12px;
    background-color: #fff;
    border: rgba(172, 0, 93, 0.12) 1px solid;
  }
  .btn-primary:hover {
    background: red;
    transition: opacity 0.5s ease-in-out;
    color: white;
  }
  .btn-primary span {
    margin-left: 12px;
  }
  .icon-wrap {
    display: flex;
    justify-content: center;
  }
  .circle {
    height: 100px;
    width: 100px;
    display: grid;
    place-items: center;
    border-radius: 100%;
    background: white;
    font-size: 40px;
  }
`;

export default function RsvpForm() {
  const [message, setMessage] = useState("");

  const submitForm = (values) => {
    console.log(values);
    setMessage("thanks for your response");
  };

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    trad: "",
    church: "",
    reception: "",
    feedback: "",
  };
  return (
    <>
      <Layout>
        <div className="icon-wrap">
          <span className="circle">
            <MailOutlined />
          </span>
        </div>
        <Formik
          initialValues={initialValues}
          // validate={validate}
          onSubmit={submitForm}
          validationSchema={Yup.object({
            firstName: Yup.string()
              .min(2, "Too Short!")
              .max(50, "Too Long!")
              .required("Firstname is required"),

            lastName: Yup.string()
              .min(2, "Too Short!")
              .max(50, "Too Long!")
              .required("Lastname is required"),
            email: Yup.string()
              .email("Invalid email address")
              .required("Email is Required"),
          })}
        >
          {(formik) => {
            const {
              values,
              handleChange,
              handleSubmit,
              handleBlur,
              isValid,
              touched,
              errors,
              dirty,
            } = formik;
            return (
              <div className="container">
                {message && <span variant="danger">{message}</span>}
                <Form onSubmit={handleSubmit} className="form">
                  <div className="form-row">
                    <div className="">
                      <label htmlFor="firstName">FirstName</label>
                      <input
                        className="input"
                        type="text"
                        name="firstName"
                        id="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.firstName && touched.firstName && (
                        <span className="error">{errors.firstName}</span>
                      )}
                    </div>
                    <div className="">
                      <label htmlFor="lastName">lastName</label>
                      <input
                        className="input"
                        type="text"
                        name="lastName"
                        id="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.lastName && touched.lastName && (
                        <span className="error">{errors.lastName}</span>
                      )}
                    </div>
                  </div>
                  <div className="">
                    <label htmlFor="email">Email</label>
                    <input
                      className="input2"
                      type="email"
                      name="email"
                      id="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.email && touched.email && (
                      <span className="error">{errors.email}</span>
                    )}
                  </div>
                  <p className="title">i will attend</p>
                  <div className="check-container" style={{ marginBottom: 32 }}>
                    <div className="btn-primary">
                      <label htmlFor="trad" className="attend">
                        <input
                          type="checkbox"
                          name="trad"
                          id="trad"
                          value={values.trad}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <span>Traditional</span>
                      </label>
                    </div>
                    <div className="btn-primary">
                      <label htmlFor="church" className="attend">
                        <input
                          type="checkbox"
                          name="church"
                          id="church"
                          value={values.church}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <span>Church Service</span>
                      </label>
                    </div>
                    <div className="btn-primary">
                      <label htmlFor="reception" className="attend">
                        <input
                          type="checkbox"
                          name="reception"
                          id="reception"
                          value={values.reception}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <span>Reception</span>
                      </label>
                    </div>
                  </div>
                  <div className="">
                    <label htmlFor="feedback">please leave a message</label>
                    <textarea
                      type="text"
                      name="feedback"
                      id="feedback"
                      value={values.feedback}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>

                  <button
                    style={styles.button}
                    type="submit"
                    className={dirty && isValid ? "" : "disabled-btn"}
                    disabled={!(dirty && isValid)}
                  >
                    Submit
                  </button>
                </Form>
              </div>
            );
          }}
        </Formik>
      </Layout>
    </>
  );
}

const styles = {
  button: {
    display: "inline-block",
    margin: " 20px auto",
    backgroundColor: "#fff",
    fontFamily: `"Oswald", sans-serif;`,
    background: " #f0394d",
    color: "#fff",
    width: "100%",
    height: 44,
    padding: " 10px 50px",
    fontSsize: "16px",
    border: "none",
    textTransform: "uppercase",
    cursor: "pointer",
  },
  hover: {
    background: "#fff",
    border: "solid 1px #6a6a6a",
  },
};
